import { Dispatch, FC, SetStateAction } from 'react'
import { Row } from '../../core/Components'
import { gray12 } from '../../platform/color'
import { Tab } from '../../platform/explore/common/Tabs'

interface Props {
  tabs: { title: string; value: string }[]
  selectedTab: string
  setSelectedTab: Dispatch<SetStateAction<string>>
}
const DNATabs: FC<Props> = ({ tabs, selectedTab, setSelectedTab }) => (
  <Row css={{ width: '100%', borderBottom: `1px solid ${gray12}` }}>
    {tabs.map(({ title, value }) => (
      <Tab onClick={() => setSelectedTab(value)} active={selectedTab === value} key={value}>
        {title}
      </Tab>
    ))}
  </Row>
)

export default DNATabs
